export default "__VITE_ASSET__Ahm6YONn__"